import { render, staticRenderFns } from "./circulo-credito-score-dashboard.vue?vue&type=template&id=5a84e404&scoped=true&"
import script from "./circulo-credito-score-dashboard.vue?vue&type=script&lang=js&"
export * from "./circulo-credito-score-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84e404",
  null
  
)

export default component.exports